<ng-container [formGroup]="parentFormGroup">
  <pg-list-select
    [id]="listSelectModel?.id"
    [formControlName]="listSelectModel?.formControlName"
  >
    <pg-list-select-item
      *ngFor="let option of listSelectModel.options"
      [value]="option.value"
    >
      <span pgTitle *ngIf="option.label">{{ option.label }}</span>
      <span pgSubtitle *ngIf="option.hint">{{ option.hint }}</span>
    </pg-list-select-item>
  </pg-list-select>
</ng-container>
